"use client";

import { type ReactNode, createContext, useContext } from "react";

import type { ShopCatalogImageLayout } from "@/types/tenant";

interface CatalogImageLayoutSettings {
  catalogImageLayout: ShopCatalogImageLayout;
}

const CatalogImageLayoutContext = createContext<CatalogImageLayoutSettings>({
  catalogImageLayout: "WIDE",
});

export function CatalogImageLayoutProvider({
  catalogImageLayout,
  children,
}: CatalogImageLayoutSettings & { children: ReactNode }) {
  return (
    <CatalogImageLayoutContext.Provider value={{ catalogImageLayout }}>
      {children}
    </CatalogImageLayoutContext.Provider>
  );
}

export function useCatalogImageLayout(): CatalogImageLayoutSettings {
  return useContext(CatalogImageLayoutContext);
}
